export function calculateNextIntervalStep(inputValue: number, samplingStep: number): number {
  const division = inputValue / samplingStep;
  const multiplicator = inputValue < 0 ? Math.floor(division) : Math.ceil(division);

  return (multiplicator * samplingStep);
}
